import { useContext } from "react";
import TranslationContext from "../translation/TranslationContext";
export var useTranslation = function () { return useContext(TranslationContext); };
